export default "__VITE_ASSET__CI3mxR3d__"